import React, { useState } from "react";
import AudioUploadPage from "../AudioUploadPage";
import WithoutWaterMark from "./WithoutWaterMark";
import { useParams } from "react-router-dom";
import Header from "../common/Header";
import { Upload, Package } from "lucide-react";

const JingleTabsPage = ({ user, onLogout }) => {
  const [activeTab, setActiveTab] = useState("withWatermark");
  const params = useParams();
  const orderId = params.id;

  return (
    <div className="min-h-screen bg-gray-50">
      <Header user={user} onLogout={onLogout} />

      <div className="max-w-7xl mx-auto p-2">
        {/* Simple tabs at the top */}
        <div className="flex gap-2 mb-3">
          <button
            onClick={() => setActiveTab("withWatermark")}
            className={`px-3 py-1.5 rounded-full text-sm font-medium flex items-center gap-1 ${activeTab === "withWatermark"
              ? "bg-orange-500 text-white"
              : "bg-white text-gray-600 border border-gray-300 hover:border-gray-400"
              }`}
          >
            <Upload className="w-3.5 h-3.5" />
            Watermark
          </button>
          <button
            onClick={() => setActiveTab("withoutWatermark")}
            className={`px-3 py-1.5 rounded-full text-sm font-medium flex items-center gap-1 ${activeTab === "withoutWatermark"
              ? "bg-orange-500 text-white"
              : "bg-white text-gray-600 border border-gray-300 hover:border-gray-400"
              }`}
          >
            <Package className="w-3.5 h-3.5" />
            Delivery
          </button>
        </div>

        {/* Content */}
        <div className="bg-white rounded-lg border border-gray-200">
          {activeTab === "withWatermark" && (
            <AudioUploadPage order_Id={orderId} />
          )}
          {activeTab === "withoutWatermark" && (
            <WithoutWaterMark order_Id={orderId} />
          )}
        </div>
      </div>
    </div>
  );
};

export default JingleTabsPage;